import React from "react";
//import { Image } from "expo-image";
import { Platform } from "react-native";
import { SvgUri } from "react-native-svg";

if (Platform.OS === "web") {
  var { Image } = require("expo-image");
}

const FastImage = ({ style, source, svg = false }) => {
  return Platform.OS === "web" ? (
    <Image style={style} contentFit="contain" source={source} />
  ) : svg ? (
    <SvgUri width="50" height="50" uri={source} />
  ) : (
    <FastImage
      resizeMode={FastImage.resizeMode.contain}
      style={style}
      source={source}
    />
  );
};

export default FastImage;
